<template>
  <!-- 外层套一个div，解决append-to-body时候报错，栈溢出 -->
  <div>
    <!-- 用mk-submenu还是会出现栈溢出问题 -->
    <el-submenu
      class="mk-aside-menu-item"
      :index="parentItem.link"
    >
      <template slot="title">
        <mk-iconfont
          :icon-class="parentItem.icon"
          :class="!isCollapse ? 'mk-icon' : ''"
        >
        </mk-iconfont>
        <span
          slot="title"
          class="menu-title"
        >
          {{ parentItem.name }}
        </span>
        <template>
          <i
            v-show="isCollapse"
            class="el-icon-caret-bottom"
          >
          </i>
        </template>
      </template>
      <template v-for="item in parentItem.menu">
        <mk-aside-menu-item
          v-if="item.menu && item.menu.length > 0"
          :key="item.id"
          :parent-item="item"
        />
        <mk-menu-item
          :key="item.id"
          :index="item.link"
        >
          <!-- <i :class="item.icon"></i> -->
          <span slot="title">{{ item.name }}</span>
        </mk-menu-item>
      </template>
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: 'MkAsideMenuItem',
  props: {
    parentItem: {
      type: Object,
      default () {
        return {}
      }
    },
    isCollapse: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.mk-aside-menu-item {
  /deep/ .el-submenu__icon-arrow {
    display: none;
  }

  /deep/ .el-menu-item {
    padding-left: 54px !important;
  }

  /deep/ .el-icon-caret-bottom {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 12px;
  }

  .mk-icon {
    font-size: 18px;
  }

  /deep/ .is-active {
    color: #fff;
  }
}

.mk-aside-menu-item.is-opened {
  /deep/ .el-icon-caret-bottom {
    transform: rotateZ(180deg);
  }
}

.mk-aside-menu-item.is-active {
  /deep/ .mk-icon {
    color: #fff;
  }
}

// 解决外层包裹div带来的样式问题

.el-menu--collapse > div > .el-submenu > .el-submenu__title span {
  height: 0;
  width: 0;
  overflow: hidden;
  visibility: hidden;
  display: inline-block;
}

.el-menu--collapse > div > .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
  display: none;
}
</style>
